import React, { useEffect, useMemo, useState } from 'react'
import styled from 'styled-components'
import CardTasksNotes from '../../common/cards/CardTasksNotes.jsx';
import RequestsHotelsCardTitle from './RequestsHotelsCardTitle.jsx';
import CardClient from '../../common/cards/CardClient.jsx';
import CardFinalClient from '../../common/cards/CardFinalClient.jsx';
import Card from '../../common/cards/Card.jsx';
import BadgeStatus from '../../common/badges/BadgeStatus.jsx';
import ButtonDetailsRequestsHotels from '../../common/buttons/ButtonDetailsRequestsHotels.jsx';
import TooltipSimple from '../../common/tooltips/TooltipSimple.jsx';
import CardManager from '../../common/cards/CardManager';
import RequestsHotelsInfos from '../../common/requests_hotels/RequestsHotelsInfos';
import { useAppStore } from '../../../../stores/useAppStore';
import useRefreshStore from '../../../../stores/refreshStore';

export default function RequestsHotelsCard(props){
	const { 
		id, 
		request,
		img, 
		requestsDate,
		title, 
		checkin,
		checkout,
		accommodation,
		status,
		hotel,
		refRequest,
		refHotel,
		refCustomer,
		segment,
		nbView,
		lastView,
		lastViews,
		conseiller,
		requestManager,
		manager,
		task,
		note,
		customer,
		finalClient,
		societe,
		echeancier,
		products_orders,
		totalHt,
		totalPayed,
		devise,
		requests,
		hasFunctionSheets,
		connectivityInfos,
		hasQuote,
		badge,
		buttonDetails,
		commission,
		hasModeration = false,
		frameworkAgreement,
		dateActivated,
		prioritySlug: prioritySlugProp
	} = props
	
	const right_gestion_clients = !!AUTH.membres_rights.includes('gps_gestion_clients');
	const right_fiches_fonction = !!AUTH.membres_rights.includes('gps_fiches_fonctions');

	const { account } = useAppStore();

	const { refresh, refreshItem, executeRefreshItem } = useRefreshStore();
	const now = useMemo(() => Date.now(), []);

	const [prioritySlug, setPrioritySlug] = useState(prioritySlugProp);
	useEffect(() => setPrioritySlug(prioritySlugProp), [prioritySlugProp]);

	useEffect(() => {
		executeRefreshItem(now, id, () => {
			setPrioritySlug(refreshItem.item.slug);
		})
	}, [refresh.refreshRequestHotelPriority]);

	
	let customerCard = '';
	if(request.scope == 'groupcorner'){
		customerCard = <CardManager manager={conseiller}
		linkProps={{
			href: '#',
			'data-part': '+',
			'data-target': 'providers//requests_hotels/contact_infos/' + id,
			'className': 'js-nav get_part_link'
		}}/>				
	}else if(societe.central_desk == 1 && requestManager){
		customerCard = 
			<CardManager manager={{
					...requestManager,
					lastName: requestManager.fullname,
					firstName: ''
				}}
				icon={requestManager?.icon}
				textColor={requestManager?.textColor}
				othersManagersCount={requestManager?.othersManagersCount}
				linkProps={{
				href: '#',
				'data-part': '+',
				'data-target': 'providers//requests_hotels/contact_infos/' + id,
				'className': 'js-nav get_part_link'
			}} />
	}else if(
		request.products_orders_moderation == 0 || status == 'rh_attente_paiement_client' || status == 'rh_reservee' || status == 'rh_client_souhaite_reserver'
	){
		customerCard = right_gestion_clients ? (
			<a 
				href="#"
				data-part="+"
				data-target={'providers//clients/profile/' + customer.id}
				data-societes_id={societe.id}
				className="js-nav get_part_link"
			>
				<CardClient client={customer} details={customer.id != finalClient.id ? false : true}/>	
			</a>
		) : (
			<div className="card-disabled">
				<CardClient client={customer} />
			</div>
		)
	}

	let backgroundImage = null;
	if(img && !img.img_error) {
		backgroundImage = {
			backgroundImage: `url("` + img.url + `")`
		}
	}
	
	/* Bidouille à Jacky pour avoir une prop compatible avec le composant typescript */
	const requestHotelInfosProp = {
		id: id,
		request: {
			id: requests.id,
			refClient: refCustomer,
			dateCreated: requests.timestamp,
			source: requests.source,
			societe: {
				id: requests.societes_id
			},
			requestClassicData: {
				nbPaxTotal: accommodation ? 1 : 0
			},
			formRequest: {
				name: requests.forms_requests_name
			},
			frameworkAgreement: frameworkAgreement,
			segmentation: {
				label: segment
			}
		},
		hotel: {
			title: hotel
		},
		connectivityInfos: connectivityInfos,
		commissionStatus: {slug: commission?.status },
		commissionRate: commission?.rate,
		nbVueUser: lastViews?.client?.nb,
		vuUser: lastViews?.client?.last,
		nbVueHotelier: lastViews?.hotelier?.nb,
		vuHotelier: lastViews?.hotelier?.last,
		dateActivated:dateActivated
	}

	const showSegmentation = (
		requests.societes_id == societe.id
		&& societe.central_desk != 1
		&& societe.segmentation_active == 1
	);
	
	const canDuplicate = (
		societe?.central_desk != 1
		&& requests?.source != 'gc'
	);

	const showFormRequest = (
		requests.societes_id == societe.id
		&& requests.source == 'web'
	);

	return (
		<Wrapper className="col-12 mb-3">
			<Card backgroundImg={img.url}>
				<div className="card-header text-gc-dark-blue p-0 pb-4">
					<div className="d-block d-md-flex justify-content-between align-items-center">
						<div className="order-last order-md-first">
							<div className="mb-2">
								<RequestsHotelsCardTitle 
									id={id}
									title={title} 
									refRequest={refRequest}
									refHotel={refHotel} 
									requestsDate={requestsDate} 
									checkin={checkin} 
									checkout={checkout}
									showTitle={true}
									showManager={true}
									manager={manager}
									showBudget={false}
									badgeBgColor={'light'}
									prioritySlug={prioritySlug}
								/>								
							</div>

							<RequestsHotelsInfos
                                requestHotel={requestHotelInfosProp}
								showSegmentation={showSegmentation}
								showFormRequest={showFormRequest}
								canManage={true}
								canDuplicate={canDuplicate}
								canEditFrameworkAgreement={account?.rights?.framework_agreements}
                            />

						</div>
						<div className="order-first order-md-last text-left text-md-right mt-4 mt-md-0">
							<BadgeStatus badge={badge} />
						</div>
					</div>
				</div>
				<div className="card-body text-gc-dark-blue p-0">
					<div className="row">
						<div className="col-12 col-xl-6">
							<div className="row">
								<div className={(customer.id != finalClient.id ? "col-6 col-md-3" : "col-12 col-md-6") + " mb-2 mb-xl-0 pr-1"}>
									{customerCard}
								</div>
								{(customer.id != finalClient.id && !hasModeration) && 
									<div className="col-6 col-md-3 mb-2 mb-xl-0 pl-1 pr-md-1">
										{(societe.id == currentSocieteId) ? (
											<a 
												href="#"
												data-part="+"
												data-target={'providers//clients/profile/' + finalClient.id + '/' + societe.id}
												className="js-nav get_part_link"
											>
												<CardFinalClient client={finalClient}/>				
											</a>
										) : (
											<div className="card-disabled h-100">
												<CardClient
													client={finalClient}
												/>
											</div>
										)
										}
									</div>
								}
								<div className="col-6 col-md-3 mb-2 mb-xl-0 pl-md-1 pr-1">
									<TooltipSimple
										title={
											echeancier.id ? 
											'booking_amount'.trad()
											: 
											(
												hasQuote ?
												'quote_amount'.trad()
												:
												'budget_amount'.trad()
											)
										}
									>
										<a
											href="#"
											data-part="+"
											data-target={
												echeancier.id ? 
												('providers//echeanciers/edit/' + echeancier.id) 
												: 
												('providers//requests_hotels/details/' + id)
											}
											data-societes_id={societe.id}
											className="js-nav get_part_link"
										>
											<div className="card border-none bg-white p-1">
												<div className="d-flex align-items-center m-auto">
													<div>
														{
															echeancier.id ? 
															<i className="fa-regular fa-money-bill-wave"></i>
															: 
															(
																hasQuote ?
																<i className="far fa-folder fa-fw"></i>
																:
																<i className="fa-solid fa-calculator"></i>
															)
														}
													</div>
													<div className="ml-2 card-btn-text">
														{
															status == 'rh_attente_paiement_client' && echeancier.id ?
															<span className="d-block h6 font-weight-bold m-0" style={{lineHeight: '1rem'}}>
																{totalPayed.formatMoneyK(devise)} / {totalHt.formatMoneyK(devise)}
															</span>
															:
															<span className="d-block h6 font-weight-bold m-0" style={{lineHeight: '1rem'}}>
																{totalHt != 0 ? totalHt.formatMoneyK(products_orders.id ? devise : request.devises_code_iso) : 'non_communique'.trad()}
															</span>
														}
													</div>
												</div>
												{
													echeancier.id && echeancier.next_echeance_amount != null && 
													<div className="d-flex align-items-center mx-auto">
														{
															echeancier.id && echeancier.next_echeance_date_diff < 0 ? 
															<small className="d-block small text-danger text-center">
																<i className="fa-solid fa-triangle-exclamation mr-1"></i>
																{'to_be_paid_since'.trad({
																montant: echeancier.to_be_payed.formatMoneyK(devise),
																nb: Math.abs(echeancier.next_echeance_date_diff)
															})}</small>
															: 
															(
																echeancier.id && echeancier.next_echeance_date_diff <= 10 ?
																<small className="d-block small text-gc-orange text-center">{'to_be_paid_in'.trad({
																	montant: echeancier.next_echeance_amount.formatMoneyK(devise),
																	nb: Math.abs(echeancier.next_echeance_date_diff)
																})}</small>
																:
																(
																	echeancier.id && echeancier.next_echeance_date_diff > 10 ?
																	<small className="d-block small text-gc-dark-blue text-center">{'to_be_paid_in'.trad({
																		montant: echeancier.next_echeance_amount.formatMoneyK(devise),
																		nb: Math.abs(echeancier.next_echeance_date_diff)
																	})}</small>
																	:
																	''
																)
															)
														}
														
													</div>
												}
											</div>									
										</a>										
									</TooltipSimple>
								</div>
								{
								(right_fiches_fonction && (status == 'rh_reservee' || status == 'rh_attente_paiement_client') && products_orders?.products_orders_type !== 'external_quote') ?
								<div className="col-6 col-md-3 mb-2 mb-xl-0 pl-1 pr-md-1">
									<a 
										href="#"
										data-part="+"
										data-target={echeancier.id ? ( hasFunctionSheets == 1 ? 'providers//function_sheets/view/' + id : 'providers//function_sheets/manage/' + id ) : '#'}
										data-societes_id={societe.id}
										className="js-nav get_part_link"
									>
										<div className="card border-none bg-white p-3">
											<div className="d-flex align-items-center m-auto">
												<div>
													<i className={"fa-regular fa-file-lines " + ( hasFunctionSheets == 1 ? '' : 'text-gc-orange' )}></i>
												</div>
												<div className="ml-2 card-btn-text">
													{
														hasFunctionSheets == 1 ?
														<span className="d-block h6 font-weight-bold m-0" style={{lineHeight: '1rem'}}>{'fiche_de_fonction'.trad()}</span>
														:
														<span className="d-block h6 font-weight-bold m-0 text-gc-orange" style={{lineHeight: '1rem'}}>{'fiche_de_fonction_create'.trad()}</span>
													}
												</div>
											</div>
										</div>									
									</a>				
								</div>
								:
								''
								}
							</div>
						</div>
						<div className="col-12 col-xl-6">
							<div className="row">
								<div className="col-12 col-md-6 mb-2 mb-xl-0 pl-xl-1 pr-md-1">
									<CardTasksNotes 
										managerId={manager.id}
										clientId={customer.id} 
										id={id} 
										task={task} 
										note={note} 
										nbVolet={1}
									/>	
								</div>
								<div className="col-12 col-md-6 pl-md-1">
									<a 
										href="#"
										data-part="+"
										data-target={'providers//requests_hotels/details/' + id}
										className='js-nav get_part_link'
									>
										<ButtonDetailsRequestsHotels
											button={buttonDetails}
											className="h5"
										>
										</ButtonDetailsRequestsHotels>						
									</a>						
								</div>
							</div>
						</div>
					</div>
				</div>
			</Card>
		</Wrapper>
	);
}

const Wrapper = styled.div`
`